import { isThisSecond } from 'date-fns'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['header', 'button', 'content']
  static scrollTop
  static headerHeight
  static offset

  connect() {
    this.headerHeight = this.headerTarget.offsetHeight
    this.resize()
  }

  change() {
    this.scrollTop = window.pageYOffset

    if (this.scrollTop !== 0) {
      if (this.scrollTop > this.headerHeight) {
        this.headerTarget.classList.add('-fixed')
      }
    } else {
      this.headerTarget.classList.remove('-fixed')
    }
  }

  resize() {
    const matchMedia = window.matchMedia('(max-width: 768px)').matches
    const ariaExpanded = !this.buttonTarget.getAttribute('aria-expanded')

    if (matchMedia && ariaExpanded) {
      this.contentTarget.setAttribute('aria-hidden', 'true')
      this.buttonTarget.setAttribute('aria-expanded', 'false')
      this.buttonTarget.setAttribute('aria-controls', 'global-menu')
    }

    if (!matchMedia && !ariaExpanded) {
      this.contentTarget.removeAttribute('aria-hidden')
      this.buttonTarget.removeAttribute('aria-expanded')
      this.buttonTarget.removeAttribute('aria-controls')
    }
  }

  toggle() {
    const ariaExpanded = this.buttonTarget.getAttribute('aria-expanded')
    const $body = document.body
    const THAT = this
    function noScroll(event) {
      event.preventDefault();
    }

    if (ariaExpanded == 'true') {
      this.contentTarget.setAttribute('aria-hidden', 'true')
      this.buttonTarget.setAttribute('aria-expanded', 'false')
      this.headerTarget.classList.remove('-bg')
      this.contentTarget.removeEventListener('touchmove', noScroll, { passive: false });
    } else {
      this.contentTarget.setAttribute('aria-hidden', 'false')
      this.buttonTarget.setAttribute('aria-expanded', 'true')
      this.headerTarget.classList.add('-bg')
      this.contentTarget.addEventListener('touchmove', noScroll, { passive: false });
    }
  }
}